import React from 'react';
import Header from "../../components/header/Header";
import FooterSection from "../../components/footer/FooterSection";
import BrandAssetsStartSection from "./sections/startSection/BrandAssetsStartSection";
import NfdProductsLogosSection from "./sections/nfdProductsLogosSection/NfdProductsLogosSection";
import TradingBotChainsSection from "./sections/tradingBotChainsSection/TradingBotChainsSection";
import NfdFontsSection from "./sections/nfdFontsSection/NfdFontsSection";
import NfdColorsSection from "./sections/nfdColorsSection/NfdColorsSection";
import BannersSection from "./sections/bannersSection/BannersSection";

export function downloadBlob(blob: any, filename: string) {
	const objectUrl = URL.createObjectURL(blob);
	
	const link = document.createElement("a");
	link.href = objectUrl;
	link.download = filename;
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
	
	setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);
}

const BrandAssets = () => {
	return (
		<div className={`brandAssetsSection`}>
			<Header mode={'dark'} />
			<BrandAssetsStartSection />
	 		<NfdProductsLogosSection />
			<TradingBotChainsSection />
			<BannersSection />
			<NfdFontsSection />
			<NfdColorsSection />
			<FooterSection />
		</div>
	);
};

export default BrandAssets;